import { render, staticRenderFns } from "./SettingsDepartments.vue?vue&type=template&id=0ac76637&scoped=true"
import script from "./SettingsDepartments.vue?vue&type=script&lang=js"
export * from "./SettingsDepartments.vue?vue&type=script&lang=js"
import style0 from "./SettingsDepartments.vue?vue&type=style&index=0&id=0ac76637&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac76637",
  null
  
)

export default component.exports